<template>
  <header
    class="navbar sticky-top flex-md-nowrap p-0"
    style="background-color: #058cf5"
  >
    <a class="navbar-brand col-lg-2 px-3 fs-6" href="/">
      <img
        id="logo"
        class="rounded border border-white"
        src="https://firebasestorage.googleapis.com/v0/b/flycomps-edc4b.appspot.com/o/flycomps-logo.png?alt=media&token=0805dd90-5c16-48e9-bd44-8f1e15746f5a"
      />
    </a>
    <button
      class="navbar-toggler border-0 shadow-none d-lg-none"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasResponsive"
      aria-controls="offcanvasResponsive"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </header>
  <RouterView />
</template>

<style>
@media (min-width: 992px) {
  .sidebar {
    top: 60px;
  }
}
</style>
